export const firebaseConfig = {
    apiKey: "AIzaSyCGxH9tHuNQmJmrYPXi96wlEGr1FBebpF8",
    authDomain: "creative-agency-406a4.firebaseapp.com",
    databaseURL: "https://creative-agency-406a4.firebaseio.com",
    projectId: "creative-agency-406a4",
    storageBucket: "creative-agency-406a4.appspot.com",
    messagingSenderId: "945784224358",
    appId: "1:945784224358:web:e2e3896db42c154e394ba7"
};